import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

export const LearnerProgressApi = createApi({
  reducerPath: "learnerProgress",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    overallAttendance: builder.query({
      query: (eventId) => ({
        body: gql`
        query{
            getAgendaProgress(eventId:"${eventId}")
              {
                error
                data
                {
                  eventId
                  userId
                  agendaProgress{
                    agendaId
                    totalFrozenAttendanceCount
                    overAllAttendance
                    userAttendanceType1Count
                  }
                }
              }
              
            }
        `,
        url: "/graphql"
      }),
      extraOptions: { service: "Attendance" }
    })
  })
});

export const { useOverallAttendanceQuery } = LearnerProgressApi;
